// Frozen manual-pilot contracts; not selected by the normal manifest.
export const BUTTERFLY_FOUR_WING_BINDINGS={
  "923017895d19fb66195f6f36531d778fb0435022b1b4f8e97afcf60cb69cdf8d": {
    "family": "butterfly",
    "variant": 0,
    "sha256": "923017895d19fb66195f6f36531d778fb0435022b1b4f8e97afcf60cb69cdf8d",
    "fourWingProfile": "butterfly-four-wing-study-4",
    "strictRoleBinds": true,
    "roles": {
      "butterfly_monarch_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ],
        "triangles": 1248,
        "vertices": 986,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "butterfly_monarch_forewing_L": {
        "canonical_role": "butterfly_forewing_L",
        "pivot_three": [
          -0.005,
          0.0,
          -0.018
        ],
        "triangles": 640,
        "vertices": 322,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_monarch_hindwing_L": {
        "canonical_role": "butterfly_hindwing_L",
        "pivot_three": [
          -0.006,
          0.0,
          -0.008
        ],
        "triangles": 576,
        "vertices": 290,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      },
      "butterfly_monarch_forewing_R": {
        "canonical_role": "butterfly_forewing_R",
        "pivot_three": [
          0.005,
          0.0,
          -0.018
        ],
        "triangles": 640,
        "vertices": 322,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_monarch_hindwing_R": {
        "canonical_role": "butterfly_hindwing_R",
        "pivot_three": [
          0.006,
          0.0,
          -0.008
        ],
        "triangles": 576,
        "vertices": 290,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      }
    },
    "detail": "full"
  },
  "ba8e275a7cbbf52343b0db2a752b50d83296beb646724a34e001de433b3777b4": {
    "family": "butterfly",
    "variant": 1,
    "sha256": "ba8e275a7cbbf52343b0db2a752b50d83296beb646724a34e001de433b3777b4",
    "fourWingProfile": "butterfly-four-wing-study-4",
    "strictRoleBinds": true,
    "roles": {
      "butterfly_common_blue_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ],
        "triangles": 1648,
        "vertices": 1368,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "butterfly_common_blue_forewing_L": {
        "canonical_role": "butterfly_forewing_L",
        "pivot_three": [
          -0.005,
          0.0,
          -0.018
        ],
        "triangles": 576,
        "vertices": 290,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_common_blue_hindwing_L": {
        "canonical_role": "butterfly_hindwing_L",
        "pivot_three": [
          -0.006,
          0.0,
          -0.008
        ],
        "triangles": 512,
        "vertices": 258,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      },
      "butterfly_common_blue_forewing_R": {
        "canonical_role": "butterfly_forewing_R",
        "pivot_three": [
          0.005,
          0.0,
          -0.018
        ],
        "triangles": 576,
        "vertices": 290,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_common_blue_hindwing_R": {
        "canonical_role": "butterfly_hindwing_R",
        "pivot_three": [
          0.006,
          0.0,
          -0.008
        ],
        "triangles": 512,
        "vertices": 258,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      }
    },
    "detail": "full"
  },
  "d0cdda684c49353ef730adf0bafc47834f9ea19f1632de231920f0ed2887d745": {
    "family": "butterfly",
    "variant": 2,
    "sha256": "d0cdda684c49353ef730adf0bafc47834f9ea19f1632de231920f0ed2887d745",
    "fourWingProfile": "butterfly-four-wing-study-4",
    "strictRoleBinds": true,
    "roles": {
      "butterfly_cabbage_white_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ],
        "triangles": 1588,
        "vertices": 1188,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "butterfly_cabbage_white_forewing_L": {
        "canonical_role": "butterfly_forewing_L",
        "pivot_three": [
          -0.005,
          0.0,
          -0.018
        ],
        "triangles": 640,
        "vertices": 322,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_cabbage_white_hindwing_L": {
        "canonical_role": "butterfly_hindwing_L",
        "pivot_three": [
          -0.006,
          0.0,
          -0.008
        ],
        "triangles": 512,
        "vertices": 258,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      },
      "butterfly_cabbage_white_forewing_R": {
        "canonical_role": "butterfly_forewing_R",
        "pivot_three": [
          0.005,
          0.0,
          -0.018
        ],
        "triangles": 640,
        "vertices": 322,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_cabbage_white_hindwing_R": {
        "canonical_role": "butterfly_hindwing_R",
        "pivot_three": [
          0.006,
          0.0,
          -0.008
        ],
        "triangles": 512,
        "vertices": 258,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      }
    },
    "detail": "full"
  },
  "87412e3b183f24784bbc169b4d74b5e99e0ebaa44c41386247a2cd2e4e6792fe": {
    "family": "butterfly",
    "variant": 0,
    "sha256": "87412e3b183f24784bbc169b4d74b5e99e0ebaa44c41386247a2cd2e4e6792fe",
    "fourWingProfile": "butterfly-four-wing-study-4",
    "strictRoleBinds": true,
    "roles": {
      "butterfly_monarch_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ],
        "triangles": 1248,
        "vertices": 986,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "butterfly_monarch_forewing_L": {
        "canonical_role": "butterfly_forewing_L",
        "pivot_three": [
          -0.005,
          0.0,
          -0.018
        ],
        "triangles": 80,
        "vertices": 42,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_monarch_hindwing_L": {
        "canonical_role": "butterfly_hindwing_L",
        "pivot_three": [
          -0.006,
          0.0,
          -0.008
        ],
        "triangles": 72,
        "vertices": 38,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      },
      "butterfly_monarch_forewing_R": {
        "canonical_role": "butterfly_forewing_R",
        "pivot_three": [
          0.005,
          0.0,
          -0.018
        ],
        "triangles": 80,
        "vertices": 42,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_monarch_hindwing_R": {
        "canonical_role": "butterfly_hindwing_R",
        "pivot_three": [
          0.006,
          0.0,
          -0.008
        ],
        "triangles": 72,
        "vertices": 38,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      }
    },
    "detail": "proxy"
  },
  "7221d77a8d8b95bfaeb713212a6f52fdf877a7e9503dc986c70738c5825e5db7": {
    "family": "butterfly",
    "variant": 1,
    "sha256": "7221d77a8d8b95bfaeb713212a6f52fdf877a7e9503dc986c70738c5825e5db7",
    "fourWingProfile": "butterfly-four-wing-study-4",
    "strictRoleBinds": true,
    "roles": {
      "butterfly_common_blue_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ],
        "triangles": 1648,
        "vertices": 1368,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "butterfly_common_blue_forewing_L": {
        "canonical_role": "butterfly_forewing_L",
        "pivot_three": [
          -0.005,
          0.0,
          -0.018
        ],
        "triangles": 72,
        "vertices": 38,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_common_blue_hindwing_L": {
        "canonical_role": "butterfly_hindwing_L",
        "pivot_three": [
          -0.006,
          0.0,
          -0.008
        ],
        "triangles": 64,
        "vertices": 34,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      },
      "butterfly_common_blue_forewing_R": {
        "canonical_role": "butterfly_forewing_R",
        "pivot_three": [
          0.005,
          0.0,
          -0.018
        ],
        "triangles": 72,
        "vertices": 38,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_common_blue_hindwing_R": {
        "canonical_role": "butterfly_hindwing_R",
        "pivot_three": [
          0.006,
          0.0,
          -0.008
        ],
        "triangles": 64,
        "vertices": 34,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      }
    },
    "detail": "proxy"
  },
  "0dfb73beb824360925745af70637628313219364760bf87a7ec399a84fd682f2": {
    "family": "butterfly",
    "variant": 2,
    "sha256": "0dfb73beb824360925745af70637628313219364760bf87a7ec399a84fd682f2",
    "fourWingProfile": "butterfly-four-wing-study-4",
    "strictRoleBinds": true,
    "roles": {
      "butterfly_cabbage_white_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ],
        "triangles": 1588,
        "vertices": 1188,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ]
      },
      "butterfly_cabbage_white_forewing_L": {
        "canonical_role": "butterfly_forewing_L",
        "pivot_three": [
          -0.005,
          0.0,
          -0.018
        ],
        "triangles": 80,
        "vertices": 42,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_cabbage_white_hindwing_L": {
        "canonical_role": "butterfly_hindwing_L",
        "pivot_three": [
          -0.006,
          0.0,
          -0.008
        ],
        "triangles": 64,
        "vertices": 34,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          -0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      },
      "butterfly_cabbage_white_forewing_R": {
        "canonical_role": "butterfly_forewing_R",
        "pivot_three": [
          0.005,
          0.0,
          -0.018
        ],
        "triangles": 80,
        "vertices": 42,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.004999999888241291,
          0,
          -0.017999999225139618,
          1
        ]
      },
      "butterfly_cabbage_white_hindwing_R": {
        "canonical_role": "butterfly_hindwing_R",
        "pivot_three": [
          0.006,
          0.0,
          -0.008
        ],
        "triangles": 64,
        "vertices": 34,
        "bind_matrix_column_major": [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0.006000000052154064,
          0,
          -0.00800000037997961,
          1
        ]
      }
    },
    "detail": "proxy"
  }
};
